var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobListEmptyIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 241,
    viewBox: "0 0 213 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17169_35639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.6 87.1992C177.9 88.2992 200.7 99.2992 207.4 118.199C213.5 135.399 201.6 145.499 199.8 146.899",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6004 98.0996C18.1004 98.4996 17.1004 99.2996 15.9004 100.4",
    stroke: "#4A5B68",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2002 105.3C6.50021 110.8 1.40021 119 0.600207 129.3C0.300207 133.5 0.800207 137.3 1.60021 140.4",
    stroke: "#4A5B68",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.88 6.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6001 143.6C3.0001 144.8 3.5001 145.9 4.0001 146.8",
    stroke: "#4A5B68",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1001 109.6L22.6001 114.2",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6001 108.899L28.2001 114.499",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M144.5 180.8C121.1 167.2 83.1002 167.2 59.5002 180.8C36.0002 194.4 35.8002 216.4 59.2002 230C82.6002 243.6 120.6 243.6 144.2 230C167.7 216.5 167.9 194.4 144.5 180.8Z",
    fill: "#083489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 194.8C161 194.5 161 194.2 161.1 193.9C161.1 193.7 161.1 193.5 161.1 193.3C161.1 193.2 161.1 193 161.1 192.9V183.1C161.1 183.4 161.1 183.8 161.1 184.1C161.1 184.4 161.1 184.7 161 185C161 185.3 160.9 185.5 160.9 185.8C160.9 186.1 160.8 186.4 160.8 186.7C160.8 187 160.7 187.2 160.6 187.5C160.5 187.8 160.5 188.1 160.4 188.4C160.3 188.7 160.2 188.9 160.2 189.2C160.1 189.5 160 189.8 159.9 190.1C159.8 190.4 159.7 190.6 159.6 190.9C159.5 191.2 159.4 191.5 159.2 191.8C159.1 192.1 159 192.3 158.8 192.6C158.7 192.9 158.5 193.2 158.4 193.5C158.3 193.7 158.1 194 158 194.2C157.8 194.5 157.6 194.9 157.4 195.2C157.3 195.4 157.1 195.7 156.9 195.9C156.7 196.2 156.4 196.6 156.2 196.9C156 197.2 155.8 197.5 155.6 197.7C155.5 197.8 155.4 197.9 155.3 198C154.9 198.5 154.6 198.9 154.1 199.3C154 199.4 154 199.4 153.9 199.5C153.5 199.9 153.2 200.3 152.8 200.7C152.7 200.8 152.6 200.9 152.5 201C152.2 201.3 151.9 201.6 151.6 201.8C151.4 202 151.1 202.2 150.9 202.5C150.6 202.8 150.3 203 149.9 203.3C149.6 203.5 149.4 203.7 149.1 203.9C148.8 204.2 148.4 204.4 148 204.7C147.7 204.9 147.5 205.1 147.2 205.3C146.8 205.6 146.4 205.8 146 206.1C145.7 206.3 145.5 206.4 145.2 206.6C144.5 207 143.8 207.5 143.1 207.9C142.2 208.4 141.2 209 140.2 209.4C139.9 209.5 139.7 209.7 139.4 209.8C138.6 210.2 137.7 210.6 136.9 211C136.7 211.1 136.5 211.2 136.3 211.3C135.3 211.7 134.2 212.2 133.2 212.5C132.9 212.6 132.7 212.7 132.4 212.8C131.5 213.1 130.7 213.4 129.8 213.7C129.5 213.8 129.2 213.9 128.9 214C128.5 214.1 128 214.3 127.6 214.4C127.2 214.5 126.7 214.7 126.3 214.8C125.9 214.9 125.4 215 125 215.1C124.6 215.2 124.1 215.3 123.6 215.4C123.2 215.5 122.7 215.6 122.3 215.7C121.8 215.8 121.4 215.9 120.9 216C120.4 216.1 120 216.2 119.5 216.3C119.1 216.4 118.6 216.5 118.2 216.5C117.1 216.7 116 216.9 114.8 217H114.7C113.6 217.2 112.5 217.3 111.4 217.4C111 217.4 110.6 217.5 110.2 217.5C109.6 217.6 108.9 217.6 108.3 217.7C107.9 217.7 107.5 217.8 107.1 217.8C106.5 217.8 105.8 217.9 105.2 217.9C104.8 217.9 104.4 217.9 103.9 218C103.4 218 102.8 218 102.3 218C101.9 218 101.4 218 101 218C100.4 218 99.9002 218 99.3002 218C98.9002 218 98.4002 218 98.0002 218C97.5002 218 97.0002 218 96.5002 217.9C96.0002 217.9 95.6002 217.9 95.1002 217.8C94.6002 217.8 94.1002 217.7 93.6002 217.7C93.1002 217.7 92.7002 217.6 92.2002 217.6C91.7002 217.6 91.2002 217.5 90.7002 217.5C90.2002 217.5 89.8002 217.4 89.3002 217.4C88.8002 217.3 88.3002 217.3 87.8002 217.2C87.4002 217.1 86.9002 217.1 86.5002 217C85.9002 216.9 85.3002 216.8 84.6002 216.7C84.3002 216.6 83.9002 216.6 83.6002 216.5C82.8002 216.4 82.1002 216.2 81.4002 216.1C81.2002 216.1 81.0002 216 80.8002 216C79.8002 215.8 78.8002 215.6 77.8002 215.3C77.5002 215.2 77.2002 215.1 76.9002 215.1C76.2002 214.9 75.5002 214.8 74.9002 214.6C74.6002 214.5 74.3002 214.4 74.0002 214.3C73.1002 214 72.2002 213.8 71.4002 213.5C71.1002 213.4 70.8002 213.3 70.6002 213.2C69.5002 212.8 68.5002 212.5 67.4002 212.1C66.9002 211.9 66.5002 211.7 66.1002 211.6C65.8002 211.5 65.4002 211.3 65.1002 211.2C64.6002 211 64.2002 210.8 63.7002 210.6C63.4002 210.5 63.1002 210.3 62.7002 210.2C62.2002 210 61.7002 209.7 61.2002 209.4C60.9002 209.3 60.7002 209.1 60.4002 209C59.7002 208.6 58.9002 208.2 58.2002 207.8C46.6002 201 40.8002 192.2 40.7002 183.4V193.2C40.7002 202 46.5002 210.9 58.2002 217.6C58.9002 218 59.7002 218.4 60.4002 218.8C60.7002 218.9 60.9002 219.1 61.2002 219.2C61.7002 219.5 62.2002 219.7 62.7002 220C63.0002 220.1 63.3002 220.3 63.6002 220.4C64.1002 220.6 64.5002 220.8 65.0002 221C65.3002 221.1 65.7002 221.3 66.0002 221.4C66.4002 221.6 66.8002 221.7 67.2002 221.9H67.3002C68.3002 222.3 69.4002 222.7 70.5002 223C70.8002 223.1 71.0002 223.2 71.3002 223.3C72.2002 223.6 73.0002 223.8 73.9002 224.1C74.1002 224.2 74.3002 224.2 74.4002 224.3C74.5002 224.3 74.6002 224.4 74.8002 224.4C75.5002 224.6 76.1002 224.8 76.8002 224.9C77.1002 225 77.4002 225.1 77.7002 225.1C78.7002 225.3 79.7002 225.6 80.7002 225.8C80.9002 225.8 81.1002 225.9 81.3002 225.9C82.0002 226 82.8002 226.2 83.6002 226.3C83.9002 226.4 84.3002 226.4 84.7002 226.5C85.3002 226.6 85.9002 226.7 86.5002 226.8C86.6002 226.8 86.6002 226.8 86.7002 226.8C87.1002 226.9 87.4002 226.9 87.8002 226.9C88.3002 227 88.8002 227 89.3002 227.1C89.7002 227.1 90.2002 227.2 90.6002 227.2C91.1002 227.2 91.6002 227.3 92.1002 227.3C92.2002 227.3 92.3002 227.3 92.4002 227.3C92.8002 227.3 93.1002 227.3 93.5002 227.4C94.0002 227.4 94.5002 227.5 95.0002 227.5C95.5002 227.5 95.9002 227.5 96.4002 227.6C96.9002 227.6 97.4002 227.6 97.9002 227.7C98.0002 227.7 98.1002 227.7 98.2002 227.7C98.5002 227.7 98.9002 227.7 99.2002 227.7C99.7002 227.7 100.3 227.7 100.8 227.7C101.2 227.7 101.7 227.7 102.1 227.7C102.6 227.7 103.2 227.7 103.7 227.7C103.9 227.7 104 227.7 104.2 227.7C104.5 227.7 104.7 227.7 105 227.7C105.6 227.7 106.3 227.6 106.9 227.6C107.3 227.6 107.7 227.5 108.1 227.5C108.7 227.5 109.4 227.4 110 227.3C110.3 227.3 110.5 227.3 110.8 227.2C110.9 227.2 111.1 227.2 111.2 227.2C112.3 227.1 113.4 227 114.5 226.8H114.6C115.7 226.6 116.8 226.5 118 226.3C118.1 226.3 118.2 226.3 118.4 226.2C118.7 226.1 119 226.1 119.3 226C119.8 225.9 120.2 225.8 120.7 225.7C121.2 225.6 121.6 225.5 122.1 225.4C122.6 225.3 123 225.2 123.5 225.1C124 225 124.4 224.9 124.9 224.8C125.3 224.7 125.8 224.6 126.2 224.5C126.6 224.4 127.1 224.2 127.5 224.1C127.9 224 128.4 223.8 128.8 223.7C128.9 223.7 129.1 223.6 129.2 223.6C129.4 223.5 129.5 223.5 129.7 223.4C130.6 223.1 131.4 222.8 132.3 222.5C132.6 222.4 132.8 222.3 133.1 222.2C134.2 221.8 135.2 221.4 136.2 221C136.4 220.9 136.6 220.8 136.8 220.7C137.7 220.3 138.5 219.9 139.3 219.5C139.6 219.4 139.8 219.2 140.1 219.1C141.1 218.6 142 218.1 143 217.6C143.7 217.2 144.4 216.8 145 216.4C145 216.4 145 216.4 145.1 216.4C145.4 216.2 145.6 216.1 145.9 215.9C146.3 215.6 146.7 215.4 147.1 215.1C147.4 214.9 147.6 214.7 147.9 214.5C148.3 214.2 148.6 214 149 213.7C149.3 213.5 149.5 213.3 149.8 213.1C150.1 212.8 150.4 212.6 150.8 212.3C151 212.1 151.3 211.9 151.5 211.6C151.7 211.4 152 211.2 152.2 211C152.3 210.9 152.3 210.9 152.4 210.8C152.5 210.7 152.6 210.6 152.7 210.5C153.1 210.1 153.5 209.7 153.8 209.3C153.9 209.2 153.9 209.2 154 209.1C154.4 208.7 154.8 208.2 155.2 207.8C155.3 207.7 155.4 207.6 155.5 207.5C155.6 207.4 155.7 207.2 155.8 207.1C155.9 207 156 206.8 156.1 206.7C156.3 206.4 156.6 206 156.8 205.7C157 205.5 157.1 205.2 157.3 205C157.5 204.7 157.7 204.3 157.9 204C158 203.9 158.1 203.7 158.2 203.6C158.3 203.5 158.3 203.4 158.3 203.3C158.5 203 158.6 202.7 158.7 202.4C158.8 202.1 159 201.9 159.1 201.6C159.2 201.3 159.3 201 159.5 200.7C159.6 200.5 159.7 200.3 159.7 200.2C159.7 200.1 159.8 200 159.8 199.9C159.9 199.6 160 199.3 160.1 199C160.2 198.7 160.3 198.5 160.3 198.2C160.4 197.9 160.4 197.6 160.5 197.3C160.5 197.1 160.6 196.9 160.6 196.7C160.6 196.6 160.6 196.5 160.6 196.5C160.7 196.2 160.7 195.9 160.7 195.6C160.9 195.3 160.9 195 161 194.8Z",
    fill: "white",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6003 158.7C82.1003 145.1 120.2 145.1 143.6 158.7C167 172.3 166.9 194.3 143.3 207.9C119.8 221.5 81.7003 221.5 58.3003 207.9C34.9003 194.4 35.1003 172.3 58.6003 158.7Z",
    fill: "#E6EBF3",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1001 180.601C94.1001 180.601 99.1001 177.501 99.9001 177.201C100.7 177.001 108 173.701 115.7 175.801C123.4 177.901 126 181.601 125.6 185.001C125.2 188.401 120.7 190.801 120.3 191.101C119.9 191.401 111.9 195.901 111.9 195.901",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8 185.401C107.8 185.401 102.8 188.501 102 188.801C101.2 189.001 93.9001 192.301 86.2001 190.201C78.5001 188.101 75.9001 184.401 76.3001 181.001C76.7001 177.601 81.2001 175.201 81.6001 174.901C82.0001 174.601 90.0001 170.101 90.0001 170.101",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5002 171.2C98.5002 171.2 85.5002 178.8 85.2002 179.2C84.8002 179.7 82.6002 182.1 85.4002 184.4C88.7002 187.1 95.4002 186.5 99.6002 183.7C103.7 180.8 111.8 177.1 117 182.3C120.3 185.6 112.7 189.2 112.7 189.2L102.2 195.4",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.3 171.2C103.5 172.2 100.5 172.3 98.7001 171.2C96.9001 170.1 96.9001 168.4 98.7001 167.4C100.5 166.3 103.5 166.3 105.3 167.4C107.1 168.4 107.1 170.1 105.3 171.2Z",
    fill: "white",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 199.101C100.2 200.101 97.2003 200.201 95.4003 199.101C93.6003 198.001 93.6003 196.301 95.4003 195.301C97.2003 194.201 100.2 194.201 102 195.301C103.8 196.301 103.8 198.001 102 199.101Z",
    fill: "white",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2003 72.0997L61.0003 90.0997C57.8003 91.8997 55.3003 96.3997 55.3003 99.9997L55.4003 106.5L55.6003 120.8L56.5003 182.9L151.9 127.8L152.1 57.0997C152.1 53.5997 149.5 52.1997 146.4 53.9997L98.1003 81.8997L98.0003 75.1997C97.9003 71.6997 95.4003 70.2997 92.2003 72.0997Z",
    fill: "white",
    stroke: "#4A5B68",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5 78.5999L72.3002 122.1C68.7002 123.8 65.3002 127.7 64.8002 130.9L56.7002 182.7L151.9 127.8L160.2 81.1999C160.7 78.0999 158.1 76.8999 154.5 78.5999Z",
    fill: "white",
    stroke: "#4A5B68",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 98.0994L131.3 107.499L152 95.7994L153.6 86.3994L133 98.0994Z",
    fill: "#1A22E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5001 99.3996L24.6001 94.7996V85.5996L32.5001 90.1996V99.3996Z",
    fill: "white",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5001 90.1994L24.6001 85.5994L32.6001 80.8994L40.5001 85.5994L32.5001 90.1994Z",
    fill: "#1A22E4",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 85.5996V94.6996L32.5 99.3996V90.1996L40.5 85.5996Z",
    fill: "white",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.3 163.499L179.4 158.899L179.3 149.699L187.3 154.299V163.499Z",
    fill: "white",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.3 154.3L179.3 149.7L187.3 145.1L195.3 149.7L187.3 154.3Z",
    fill: "#1A22E4",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.3 149.699V158.899L187.3 163.499V154.299L195.3 149.699Z",
    fill: "white",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 89.4C87.3 59.2 102.4 46.9 116.2 41.6C118.1 40.9 122.3 39.2 125.2 41.2C128.2 43.3 129 48.6 127 51.7C124.3 55.7 116.9 55.7 112.9 53.5C105.1 49.2 96.8 31.5 123.4 15",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.9 9.3L131.5 18L133.3 12.1L158.2 1L129.9 9.3Z",
    fill: "white",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5 18L158.2 1L133.3 12.1L131.5 18Z",
    fill: "white",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.2 1L141 20L133.3 12.1L158.2 1Z",
    fill: "white",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.4 5.4L129.9 9.3L158.2 1L126.4 5.4Z",
    fill: "white",
    stroke: "#4A5B68",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17169_35639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 223.9,
    height: 239.8,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobListEmptyIllustration);
export default __webpack_public_path__ + "static/media/job-list-empty-illustration.c53101ed780dd5b2a42ad956c189a7b5.svg";
export { ForwardRef as ReactComponent };